import { AvailableOnCallRequester } from '~/domain/usecases/onCallRequester/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from '~/domain/errors';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import '~/infra/global/variables';

export class RemoteAvailableOnCallRequester
  implements AvailableOnCallRequester
{
  private readonly url: string;

  private readonly httpClient: HttpClient<AvailableOnCallRequester.Model>;

  constructor(
    url: string,
    httClient: HttpClient<AvailableOnCallRequester.Model>,
  ) {
    this.url = url;
    this.httpClient = httClient;
  }

  available = async (
    params: AvailableOnCallRequester.Params,
  ): Promise<AvailableOnCallRequester.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url.replace('{requesterId}', params.requesterId.toString()),
      method: 'post',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
